import { Team } from '@internal/schemas-common';
import { VulnerabilitiesTable } from '@internal/backstage-plugin-zf-vulnerabilities';

export const OrphanedVulnerabilitiesTable = () => {
  // orphaned means team name 'unknown' - some dirty fast solution is used here
  return (
    <VulnerabilitiesTable
      teams={[
        Team.createIfCorrectFormat('teams-scalar-unknown', 'unknown', '', '')!,
      ]}
      updateScoreCb={() => {}}
      updateLoadingCb={() => {}}
      title="Orphaned Vulnerabilities"
    />
  );
};
